import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { UserService } from '../../../services/user.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { User } from '../../../classes/user';
import { CommunicationService } from '../../../services/communication.service';
import { ListingCategory } from '../../../classes/enums';
import { PreferencesService } from '../../../services/preferences.service';

@Component({
  selector: 'app-right-nav',
  templateUrl: './right-nav.component.html',
  styleUrls: ['./right-nav.component.scss'],
  animations: [
    trigger('rightNavTrigger', [
      transition(':enter', [
        style({ left: '-100vw' }),
        animate('350ms ease-out', style({ left: '0' }))
      ]),
      transition(':leave', [
        style({ left: '*' }),
        animate('350ms ease-in', style({ left: '-100vw' }))
      ])
    ])
  ]
})
export class RightNavComponent extends HasSubscriptions implements OnInit {
  currentListingType: ListingCategory;
  currentUser: User;
  @Input() showRightNav: boolean = false;
  @Output() toFavourites: EventEmitter<any> = new EventEmitter();
  @Output() toSavedSearches: EventEmitter<any> = new EventEmitter();
  @Output() openSignIn: EventEmitter<any> = new EventEmitter();
  @Output() toMyAccount: EventEmitter<any> = new EventEmitter();
  @Output() logout: EventEmitter<any> = new EventEmitter();
  @Output() toFavouriteAgent: EventEmitter<string> = new EventEmitter();

  @Output() onCloseRightNavClick: EventEmitter<void> = new EventEmitter();
  ListingCategory = ListingCategory;

  agentUrl: string;
  constructor(
    private userService: UserService,
    private communicationService: CommunicationService,
    private preferencesService: PreferencesService) {
    super();
    this.addSub(this.preferencesService.favouriteAgentUrlChanged.subscribe((url) => this.agentUrl = url));
  }

  ngOnInit() {
    this.addSub(this.userService.currentUser.subscribe((currentUser) => this.currentUser = currentUser));
    this.addSub(this.communicationService.listings.currentShownListingType.subscribe((listingType) => this.currentListingType = listingType));
  }

}
